import axios from './api'
const SettingServer = {
	getOrgInfo(params) {
		return axios.get(`/org/system/org/info`, {params: params}).then((res) => {
            return res.data
        })
	},

    getLastestOrgAuthAudit(params) {
		return axios.get(`/org/orgAudit/load`, {params: params}).then((res) => {
            return res.data
        })
	},

    upload(params) {
		return axios.post(`/org/base/file/upload`, params, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then((res) => {
			return res.data
		})
	},

    orgAuth(params) {
		return axios.post(`/org/orgAudit/submit`, params).then((res) => {
            return res.data
        })
	},

    getLastestAccountAuthAudit(params) {
		return axios.get(`/org/orgUserAudit/load`, {params: params}).then((res) => {
            return res.data
        })
	},

    accountAuth(params) {
		return axios.post(`/org/orgUserAudit/submit`, params).then((res) => {
            return res.data
        })
	},

    getAccountInfo(params) {
        return axios.get(`/org/user/auth/userInfo`, {params: params}).then((res) => {
            return res.data
        })
    },

    getRechargePackagePageList(params) {
		return axios.post(`/org/rechargePackage/pageList`, params).then((res) => {
            return res.data
        })
	},

    // 获取支付渠道
    getCashierTypeList(params) {
        return axios.get(`/org/cashier/cashierTypeList`, {params: params}).then((res) => {
            return res.data
        })        
    },

    // 提交钱包充值
    submitRechargeOrder(params) {
		return axios.post(`/org/orgWallet/recharge/order`, params).then((res) => {
            return res.data
        })
	},

    // 提交收银台
    submitCashier(params) {
		return axios.post(`/org/cashier/submitCashier`, params).then((res) => {
            return res.data
        })
	},

    // 查询支付订单列表
    getRechargeOrderPageList(params) {
		return axios.post(`/org/orgWallet/pageList`, params).then((res) => {
            return res.data
        })
	},

    // 查询钱包记录列表
    getWalletReocrdPageList(params) {
        return axios.post(`/org/orgWallet/trans/pageList`, params).then((res) => {
            return res.data
        })
    },

    // 查询可订阅版本列表
    getSubscribeProductPageList(params) {
        return axios.post(`/org/subscriptionRecord/can/list`, params).then((res) => {
            return res.data
        })
    },

    // 提交版本订阅
    submitSubscribeOrder(params) {
		return axios.post(`/org/subscriptionRecord/submit`, params).then((res) => {
            return res.data
        })
	},
    
    // 私有渠道列表
    getChannelPageList(params) {
        return axios.post(`/org/system/pageList`, params).then((res) => {
            return res.data
        })
    },

    // 添加私有渠道
    addChannel(params) {
        return axios.post(`/org/system/save`, params).then((res) => {
            return res.data
        })
    },

    // 修改私有渠道
    updateChannel(params) {
        return axios.post(`/org/system/update`, params).then((res) => {
            return res.data
        })
    },

    // 修改客户池分配规则
    changeCustomerPoolRule(params) {
        return axios.post(`/org/system/edit/customer/pool/match/rule`, params).then((res) => {
            return res.data
        })
    },
}

export default SettingServer


// WEBPACK FOOTER //
// ./src/api/setting.js